import axios from 'axios';
import React, { useState } from 'react'
import Modal from 'react-bootstrap/Modal';
import toast from 'react-hot-toast';
import * as Yup from "yup";
import classNames from 'classnames';

import useCustomValidation from '../../hooks/useCustomValidation';
import useLogout from '../../hooks/useLogout';
import ValidationError from '../ValidationError';
import useTogglePassword from '../../hooks/useTogglePassword';

function CreateUserModal({ show, handleClose }) {
    const logoutUser = useLogout();

    const [isLoading, setIsLoading] = useState(false);
    const { showPassword, togglePassword } = useTogglePassword();

    const schema = {
        name: Yup.string().required("Name is required").trim(),
        password: Yup.string().required("Password is required").trim(),
    };
    const initial = {
        name: null,
        password: null,
    };
    const { register, errors, handleSubmit, reset, setValue } =
        useCustomValidation({ schema, initial });

    const createNewMerchantSubmit = async (data) => {
        setIsLoading(true)
        await axios
            .post(`${process.env.REACT_APP_API_URL}/user/create`, data)
            .then((response) => {
                const { data } = response;
                if (response.status == 201) {
                    toast.success(data.msg);
                    reset()
                    handleClose("success")
                } else {
                    toast.error(data.msg);
                }
            })
            .catch((error) => {
                const { response } = error
                if (response) {
                    const { data } = response
                    if (response?.status == 401) {
                        toast.error("Please Login!");
                        logoutUser();
                    } else if (response?.status == 400) {
                        toast.error(data.msg);
                    } else {
                        toast.error(data.msg || "Request failed!");
                    }
                }
            })
            .finally((e) => {
                setIsLoading(false)
            });

    }

    return (
        <Modal show={show} onHide={() => handleClose("manual")}>
            <Modal.Header closeButton>
                <Modal.Title>Create User</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <form onSubmit={handleSubmit(createNewMerchantSubmit)} autoComplete="off">
                    <div className="mb-3">
                        <label htmlFor='c-user-name' className="form-label">Name</label>
                        <input type="text" {...register("name")} className="form-control"
                            id="c-user-name" />
                        <ValidationError name="name" errors={errors} />
                    </div>
                    <div className="mb-3">
                        <label htmlFor="c-user-password" className="form-label">
                            Password
                        </label>
                        <div className="input-group">
                            <input
                                {...register("password", {
                                    required: "This input is required.",
                                })}
                                type={showPassword ? "text" : "password"}
                                className="form-control"
                                id="c-user-password"
                            />
                            <button
                                className="btn btn-outline-dark"
                                type="button"
                                onClick={togglePassword}
                            >
                                <span>
                                    <i
                                        className={classNames("ti", {
                                            "ti-eye": !showPassword,
                                            "ti-eye-off": showPassword,
                                        })}
                                    ></i>
                                </span>
                            </button>
                        </div>
                        <ValidationError name="password" errors={errors} />
                    </div>

                    <button type="submit" className="btn btn-primary"
                        disabled={isLoading}>
                        {isLoading && (
                            <div className="spinner-border"></div>
                        )} Create
                    </button>
                </form>
            </Modal.Body>
        </Modal>
    )
}

export default CreateUserModal